export default "/images/vendor/flag-icon-css/flags/4x3/at.svg?b511d36eecb8b5dc08f5cce85d6fccea";